export const isSpaceOrEnterPress = ({ key }: React.KeyboardEvent<Element>): boolean =>
	['Enter', 'Space'].includes(key);
